// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DropsPageQueryVariables = Types.Exact<{
  filter: Types.DropsFilter;
  entityId: Types.Scalars['ID']['input'];
}>;


export type DropsPageQuery = { __typename?: 'Query', drops: Array<{ __typename?: 'Drop', id: string, name: string, code: string, costCode: { __typename?: 'CostCode', id: string, displayName: string }, globalPlanTask: { __typename?: 'GlobalPlanTask', nameForEntity: string, id: string, name: string }, locations: Array<{ __typename?: 'Location', id: string, name: string }>, development?: { __typename?: 'Development', id: string, market: { __typename?: 'Market', id: string } } | null | undefined, project?: { __typename?: 'StandaloneProject', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Region', id: string, market?: { __typename?: 'Market', id: string } | null | undefined } | { __typename?: 'Market', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Community', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Subdivision', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Lot', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Structure', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Unit', id: string, market: { __typename?: 'Market', id: string } } | null | undefined }> };

export type DropDetailsFragment = { __typename?: 'Drop', id: string, name: string, code: string, costCode: { __typename?: 'CostCode', id: string, displayName: string }, globalPlanTask: { __typename?: 'GlobalPlanTask', nameForEntity: string, id: string, name: string }, locations: Array<{ __typename?: 'Location', id: string, name: string }>, development?: { __typename?: 'Development', id: string, market: { __typename?: 'Market', id: string } } | null | undefined, project?: { __typename?: 'StandaloneProject', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Region', id: string, market?: { __typename?: 'Market', id: string } | null | undefined } | { __typename?: 'Market', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Community', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Subdivision', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Lot', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Structure', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Unit', id: string, market: { __typename?: 'Market', id: string } } | null | undefined };

export type DeleteDropMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteDropMutation = { __typename?: 'Mutation', deleteDrop: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export const DropDetailsFragmentDoc = gql`
    fragment DropDetails on Drop {
  id
  name
  code
  costCode {
    id
    displayName
  }
  globalPlanTask {
    ...Named
    nameForEntity(entityId: $entityId)
  }
  locations {
    ...Named
  }
  development {
    id
    market {
      id
    }
  }
  project {
    id
    market {
      id
    }
  }
}
    ${NamedFragmentDoc}`;
export const DropsPageDocument = gql`
    query DropsPage($filter: DropsFilter!, $entityId: ID!) {
  drops(filter: $filter) {
    ...DropDetails
  }
}
    ${DropDetailsFragmentDoc}`;

/**
 * __useDropsPageQuery__
 *
 * To run a query within a React component, call `useDropsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDropsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDropsPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useDropsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DropsPageQuery, DropsPageQueryVariables> & ({ variables: DropsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DropsPageQuery, DropsPageQueryVariables>(DropsPageDocument, options);
      }
export function useDropsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DropsPageQuery, DropsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DropsPageQuery, DropsPageQueryVariables>(DropsPageDocument, options);
        }
// @ts-ignore
export function useDropsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DropsPageQuery, DropsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DropsPageQuery, DropsPageQueryVariables>;
export function useDropsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DropsPageQuery, DropsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DropsPageQuery | undefined, DropsPageQueryVariables>;
export function useDropsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DropsPageQuery, DropsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DropsPageQuery, DropsPageQueryVariables>(DropsPageDocument, options);
        }
export type DropsPageQueryHookResult = ReturnType<typeof useDropsPageQuery>;
export type DropsPageLazyQueryHookResult = ReturnType<typeof useDropsPageLazyQuery>;
export type DropsPageSuspenseQueryHookResult = ReturnType<typeof useDropsPageSuspenseQuery>;
export type DropsPageQueryResult = Apollo.QueryResult<DropsPageQuery, DropsPageQueryVariables>;
export const DeleteDropDocument = gql`
    mutation DeleteDrop($id: ID!) {
  deleteDrop(input: {id: $id}) {
    emptyResult
  }
}
    `;
export type DeleteDropMutationFn = Apollo.MutationFunction<DeleteDropMutation, DeleteDropMutationVariables>;

/**
 * __useDeleteDropMutation__
 *
 * To run a mutation, you first call `useDeleteDropMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDropMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDropMutation, { data, loading, error }] = useDeleteDropMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDropMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDropMutation, DeleteDropMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDropMutation, DeleteDropMutationVariables>(DeleteDropDocument, options);
      }
export type DeleteDropMutationHookResult = ReturnType<typeof useDeleteDropMutation>;
export type DeleteDropMutationResult = Apollo.MutationResult<DeleteDropMutation>;
export type DeleteDropMutationOptions = Apollo.BaseMutationOptions<DeleteDropMutation, DeleteDropMutationVariables>;